export default __webpack_public_path__ + "4e83837218f8d54ba0d2ee6e6b029ab9.svg";